import Vue from 'vue';
import ApiError from 'utils/api-error';

export async function get(url, params) {
    try {
        let query = params ? { params } : null;

        return (await Vue.axios.get(url, query)).data;
    }
    catch(error) {
        throw new ApiError(error);
    }
}

export async function post(url, data) {
    try {
        return (await Vue.axios.post(url, data)).data;
    }
    catch(error) {
        throw new ApiError(error);
    }
}

export async function put(url, data) {
    try {
        return (await Vue.axios.put(url, data)).data;
    }
    catch(error) {
        throw new ApiError(error);
    }
}

export async function del(url) {
    try {
        return (await Vue.axios.delete(url)).data;
    }
    catch(error) {
        throw new ApiError(error);
    }
}

export async function patch(url, data) {
  try {
    return (await Vue.axios.patch(url, data)).data;
  }
  catch (error) {
    throw new ApiError(error);
  }
}

function downloadBase(response, filename) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

export function download(url, filename) {
    Vue.axios.get(url, {
        responseType: 'blob'
    }).then((response) => {
        downloadBase(response, filename);
    });
}

export function downloadPost(url, data, filename) {
    Vue.axios.post(url, data, {
        responseType: 'blob'
    }).then((response) => {
        downloadBase(response, filename);
    })
}